import { initialStatisticalAnalysisTemporalFilterState, StatisticalAnalysisTemporalFilterEnum, StatisticalAnalysisTemporalFilterOptions, StatisticalAnalysisTemporalFilterState } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-temporal-filter/statistical-analysis-temporal-filter.model'
import { Vue, Component, Prop, Emit } from 'vue-property-decorator'

@Component
export default class StatisticalAnalysisTemporalFilter extends Vue {
    @Prop() readonly keyLabel!: string
    @Prop() readonly preselection!: StatisticalAnalysisTemporalFilterEnum
    @Emit()
    temporalFilter(value: StatisticalAnalysisTemporalFilterOptions): StatisticalAnalysisTemporalFilterOptions {
        return value
    }

    state: StatisticalAnalysisTemporalFilterState
    constructor() {
        super()
        this.state = initialStatisticalAnalysisTemporalFilterState()
    }

    get isLoading(): boolean {
        return this.state.externalLoading
    }

    mounted() {
        this.$eventHub.$on('statistical-loading', this._onStatisticalLoadingGridTable)
        if (this.preselection) {
            const foundTemporalItem = this.state.options.find((item: StatisticalAnalysisTemporalFilterOptions) => item.id === this.preselection)
            if (foundTemporalItem) {
                this.state.selected = foundTemporalItem
            }
        }
    }

    beforeDestroy() {
        this.$eventHub.$off('statistical-loading', this._onStatisticalLoadingGridTable)
    }

    onChange(value: StatisticalAnalysisTemporalFilterOptions): void {
        this.temporalFilter(value)
    }

    getTranslatedLabel(key: StatisticalAnalysisTemporalFilterOptions): string {
        return this.$tc(key.text)
    }

    private _onStatisticalLoadingGridTable(value: boolean): void {
        this.state.externalLoading = value
    }
}
